import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../config';
import { addTheme, deleteTheme, getTheme, getThemes } from './methods';

const useGetThemesQuery = () => {
  const { isPending, isSuccess, isError, data } = useQuery({
    queryFn: getThemes,
    queryKey: [queryKeys.themesKey],
    staleTime: Infinity,
  });

  return { data, isError, isPending, isSuccess };
};

const useGetThemeQuery = (id: number) => {
  const { isPending, isSuccess, isError, data } = useQuery({
    enabled: !!id,
    queryFn: () => getTheme(id),
    queryKey: [queryKeys.themesKey, id],
  });

  return { data, isError, isPending, isSuccess };
};

const useAddThemeMutation = () => {
  const queryClient = useQueryClient();

  const {
    isPending,
    isSuccess,
    isError,
    mutateAsync: addThemeMutation,
  } = useMutation({
    mutationFn: addTheme,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.themesKey],
      });

      queryClient.invalidateQueries({
        queryKey: [
          queryKeys.interactionsDictionaryKey,
          variables.interaction_dictionary_id,
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [queryKeys.interactionsDictionaryKey],
      });
    },
  });

  return { addThemeMutation, isError, isPending, isSuccess };
};

const useDeleteThemeMutation = () => {
  const queryClient = useQueryClient();

  const {
    isPending,
    isSuccess,
    isError,
    mutateAsync: deleteThemeMutation,
  } = useMutation({
    mutationFn: deleteTheme,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.themesKey],
      });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.interactionsDictionaryKey],
      });
    },
  });

  return { deleteThemeMutation, isError, isPending, isSuccess };
};

export {
  useAddThemeMutation,
  useDeleteThemeMutation,
  useGetThemeQuery,
  useGetThemesQuery,
};
